export default __webpack_public_path__ + "static/media/RuPay.00194ebd.png";